import OccupantDetail from "./OccupantDetail"

export default function ActiveRoomParticipantList({
  occupantList,
  participants,
  participantsLoading,
  onEditClick,
}) {
  if (!occupantList || occupantList.length === 0) {
    return <label>No occupants found</label>
  } else {
    return (
      <>
        {occupantList.map((x) => (
          <>
            <OccupantDetail
              bedOccupancy={x}
              participant={participants?.find(
                (y) => y.participant_id === x.participantId
              )}
              participantsLoading={participantsLoading}
              showEdit={!!onEditClick}
              onEditClick={onEditClick}
            />{" "}
          </>
        ))}
      </>
    )
  }
}
